import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";
import { number, oneOfType, string } from "prop-types";

import DrawerModal from "src/shared/components/DrawerModal";
import ErrorMessage from "src/shared/components/ErrorMessage";
import apolloClient from "src/shared/utilities/graphql/apolloClient";

import { agentMatchItemPropType } from "../../../../propTypes";
import MODAL_VIEW_TYPES from "../../constants/modalViewTypes";
import { useUIBehavior, useUIData } from "../../redux/hooks/uiHooks";
import AgentContactForm from "../AgentContactForm";
import MessageSent from "../MessageSent";
import * as S from "./styled";

const ExpertMatchDrawer = ({
  agentMatchItem,
  propertyId,
  rootElementId,
  userId
}) => {
  const { isExpertMatchDrawerOpen, modalViewType } = useUIData();
  const { closeExpertMatchDrawer } = useUIBehavior();

  const ariaLabelledBy = "modal_label";
  const ariaDescribedBy = "modal_description";

  const modalAriaLabel =
    modalViewType === MODAL_VIEW_TYPES.success ||
    modalViewType === MODAL_VIEW_TYPES.agentContact
      ? ariaLabelledBy
      : null;

  const modalAriaDescription =
    modalViewType === MODAL_VIEW_TYPES.success ||
    modalViewType === MODAL_VIEW_TYPES.agentContact
      ? ariaDescribedBy
      : null;

  const views = {
    [MODAL_VIEW_TYPES.agentContact]: (
      <>
        <S.FormHeader
          ariaContentDescribedBy={ariaDescribedBy}
          ariaContentLabelledBy={ariaLabelledBy}
        />
        <S.AgentCard agentMatchItem={agentMatchItem} />
        <AgentContactForm
          agentMatchItem={agentMatchItem}
          handleCancelClick={closeExpertMatchDrawer}
          propertyId={propertyId}
          userId={userId}
        />
      </>
    ),
    [MODAL_VIEW_TYPES.error]: (
      <S.MessageContainer>
        <ErrorMessage>
          Sorry, something went wrong.
          <br />
          Please try again later.
        </ErrorMessage>
      </S.MessageContainer>
    ),
    [MODAL_VIEW_TYPES.success]: (
      <S.MessageContainer>
        <MessageSent
          agentName={agentMatchItem.name}
          ariaContentDescribedBy={ariaDescribedBy}
          ariaContentLabelledBy={ariaLabelledBy}
        />
      </S.MessageContainer>
    )
  };

  return (
    <ApolloProvider client={apolloClient}>
      <DrawerModal
        aria={{
          describedby: modalAriaDescription,
          labelledby: modalAriaLabel
        }}
        handleOnClose={closeExpertMatchDrawer}
        isOpen={isExpertMatchDrawerOpen}
        render={() => (
          <S.ModalContent data-qa="seller-expert-match-drawer">
            <S.XButton
              modalViewType={modalViewType}
              onClick={closeExpertMatchDrawer}
            />
            <S.ContentContainer aria-live="polite">
              {views[modalViewType]}
            </S.ContentContainer>
          </S.ModalContent>
        )}
        rootElementId={rootElementId}
      />
    </ApolloProvider>
  );
};

ExpertMatchDrawer.propTypes = {
  agentMatchItem: agentMatchItemPropType.isRequired,
  propertyId: number.isRequired,
  rootElementId: string.isRequired,
  userId: oneOfType([number, string]).isRequired
};

export default ExpertMatchDrawer;
